import { io } from 'socket.io-client';

// Determinar la URL del socket según el entorno
const getSocketUrl = () => {
  if (process.env.REACT_APP_SOCKET_URL) {
    return process.env.REACT_APP_SOCKET_URL;
  }
  return process.env.NODE_ENV === 'production' 
    ? 'https://api.wintoncoin.com'  // URL de producción
    : 'http://localhost:3000';      // URL de desarrollo
};

// Singleton para la conexión WebSocket
class SocketService {
  constructor() {
    this.socket = null;
    this.callbacks = {};
  }

  // Inicializar conexión
  connect() {
    if (this.socket) return;

    this.socket = io(getSocketUrl(), {
      withCredentials: true,
      reconnection: true
    });

    // Manejar eventos básicos
    this.socket.on('connect', () => {
      console.log('Conectado al servidor de WebSockets');
    });

    this.socket.on('disconnect', () => {
      console.log('Desconectado del servidor de WebSockets');
    });

    // Escuchar mensajes de chat
    this.socket.on('chat message', (data) => {
      if (this.callbacks['message']) {
        this.callbacks['message'](data);
      }
    });

    // Escuchar confirmación de unirse a sala
    this.socket.on('room joined', (data) => {
      if (this.callbacks['roomJoined']) {
        this.callbacks['roomJoined'](data);
      }
    });
  }

  // Unirse a una sala de chat (entre dos usuarios)
  joinChatRoom(userId1, userId2) {
    if (!this.socket) this.connect();
    
    // Crear ID de sala ordenando los IDs
    const roomId = [userId1, userId2].sort().join('-');
    this.socket.emit('join room', { room: roomId });
    return roomId;
  }

  // Enviar mensaje
  sendMessage(sender, receiver, message) {
    if (!this.socket) this.connect();
    
    this.socket.emit('chat message', {
      sender,
      receiver,
      message
    });
  }

  // Registrar callbacks para eventos
  on(event, callback) {
    this.callbacks[event] = callback;
  }

  // Desconectar
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

// Exportar instancia única
export default new SocketService();
